import React from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../store'
import { Dispatch } from 'redux'
import { getCountryList } from '../../actions/countryActions'
import WireTransfersFormikWrap from './WireTransfersFormikWrap'
import { CashDirection, SearchAccountsResponsePayload, TransferMechanism } from '@Types'
import { AccountDetailsState } from '@Types'
import { CountryItem } from '../../reducers/types'
import { useIraConstraintsByMethod } from '../../api'

export interface WireTransferPageProps {
  account: SearchAccountsResponsePayload
  amountAvailable: number
  accountDetails?: AccountDetailsState | null
  hasSubmitPermission: boolean
  getCountryList: () => void
  countryList: CountryItem[]
  countryListLoading: boolean
  countryListFailedMessage?: string
  countryAutoSelectDataSet: { value: string }[]
}

const WireTransferPage = (props: WireTransferPageProps) => {
  const { constraintData } = useIraConstraintsByMethod(
    props.account.accountNumber,
    TransferMechanism.Wire,
    CashDirection.Withdrawal
  )
  if (constraintData) {
    return <WireTransfersFormikWrap constraintData={constraintData} {...props} />
  }
  return <div>Loading...</div>
}

const mapStateToProps = (state: RootState) => {
  const {
    countryReducer: { countryListLoading, countryList, countryListFailedMessage }
  } = state

  const countryAutoSelectDataSet = countryList
    .filter((country) => country.isoName)
    .map((country) => ({ value: country.isoName! }))

  return { countryListLoading, countryList, countryListFailedMessage, countryAutoSelectDataSet }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getCountryList: () => getCountryList(dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WireTransferPage)
